<div class="view-charges-mobile">
  <accordion [isAnimated]="true">
    <accordion-group [panelClass]="'custom-accordion'" *ngFor="let products of masterGroups">
      <div class="accordion-group-header shadow-none" accordion-heading>
        <img class="accordion-group-header__arrow" src="assets/icons/icon_chevron_up.svg" />
        <span class="accordion-group-header__label">{{ "LABELS." + products.key | translate }}</span>
        <div class="accordion-group-header__price">
          {{ getSumMasterGroup(products.items) | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
        </div>
      </div>
      <div class="d-flex flex-column">
        <div class="accordion-group-content__item" *ngFor="let bill of products.items">
          <span class="accordion-group-content__item-description">{{ bill.description }}</span>
          <div class="d-flex justify-content-between">
            <div class="accordion-group-content__item-value">
              {{ bill?.internalQuantities?.quantity }} {{ itemQuantityLabel(bill?.internalQuantities?.unit) | translate }}
            </div>
            <div class="accordion-group-content__item-value">
              {{ bill?.price / bill?.internalQuantities?.quantity || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
            </div>
            <div class="accordion-group-content__item-price">
              {{ bill?.price || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
            </div>
          </div>
        </div>
      </div>
    </accordion-group>
    <accordion-group [panelClass]="'custom-accordion'" *ngFor="let products of secondaryGroups">
      <div class="accordion-group-header shadow-none" accordion-heading>
        <img class="accordion-group-header__arrow" src="assets/icons/icon_chevron_up.svg" />
        <span class="accordion-group-header__label">{{ "LABELS." + products.key | translate }}</span>
        <div class="accordion-group-header__price">
          {{ getSumAdditionalGroup(products.items) | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
        </div>
      </div>
      <div class="d-flex flex-column">
        <div class="accordion-group-content__item" *ngFor="let bill of products.items">
          <span class="accordion-group-content__item-description">
            {{ bill?.productCode === EXPORT_LICENSE_CODE ? bill?.description : bill?.notes }}
          </span>
          <div class="d-flex justify-content-between">
            <div class="accordion-group-content__item-value">
              {{ bill?.quantity }} {{ itemQuantityLabel(bill?.internalQuantities?.unit) | translate }}
            </div>
            <div class="accordion-group-content__item-value">
              {{ bill?.price || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
            </div>
            <div class="accordion-group-content__item-price">
              {{ bill?.price * bill?.quantity || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
            </div>
          </div>
        </div>
      </div>
    </accordion-group>
  </accordion>
  <div class="payment-container">
    <div class="payment-container__label">
      <span>{{ totalFieldKey | translate : { field: "" } }}</span>
    </div>
    <div class="payment-container__cost">
      <span class="payment-label payed" *ngIf="isPaid">
        <i class="fa fa-check mr-1"></i>
        {{ "LABELS.PAID" | translate }}
      </span>
      {{ totalSum | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
    </div>
  </div>
</div>
